module.exports = __webpack_public_path__ + "static/media/Montserrat-Light.ba044963.ttf";